import React from 'react';

const ErrorMessage = ({message}) => (
  <div>
    <div className="alert alert-form-error">
      {message}
    </div>
    <hr />
  </div>
);

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/RequestForm/ErrorMessage.js